import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiAvailableIpsResponse } from './types';

type Props = { artistId: string };

export const getAvailableIps = async ({ artistId }: Props) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/ip-pools/available-ips`;

  const response = await api.executeGetRequest<ObjectResponse<ApiAvailableIpsResponse>>(url);

  return response.data;
};
